import i18n from "@/i18n/i18n";

export default {
  methods: {
    showDeleteConfirmationModal({
      title,
      message,
      confirmTextLabel = "",
      confirmTextValue = "",
    }) {
      return this.$showDeleteConfirmationModal({
        title: title || i18n.t("common.deleteItem"),
        message: message || i18n.t("common.deleteItemMessage"),
        confirmTextLabel,
        confirmTextValue,
      });
    },
  },
};
